(function () {
  var allowedHandles = ['outer', 'tops', 'pants', 'sale-1'];
  var latestRunId = 0;
  var scheduled = false;

  function hashString(value) {
    var hash = 2166136261;

    for (var index = 0; index < value.length; index += 1) {
      hash ^= value.charCodeAt(index);
      hash +=
        (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
    }

    return hash >>> 0;
  }

  function getSeed(seedMode) {
    if (seedMode === 'session') {
      var sessionSeed = sessionStorage.getItem('collection-random-seed');

      if (!sessionSeed) {
        sessionSeed = String(Date.now());
        sessionStorage.setItem('collection-random-seed', sessionSeed);
      }

      return sessionSeed;
    }

    var now = new Date();
    var year = now.getFullYear();
    var month = String(now.getMonth() + 1).padStart(2, '0');
    var day = String(now.getDate()).padStart(2, '0');

    return year + '-' + month + '-' + day;
  }

  function isAllowedHandle(handle) {
    return allowedHandles.indexOf(handle) !== -1;
  }

  function getCurrentPage() {
    var params = new URLSearchParams(window.location.search);
    return Number(params.get('page') || '1');
  }

  function getPaginationPages() {
    var links = Array.prototype.slice.call(
      document.querySelectorAll('.pagination__list .pagination__item')
    );

    var pageNumbers = links
      .map(function (node) {
        var value = Number((node.textContent || '').trim());
        return Number.isFinite(value) ? value : null;
      })
      .filter(function (value) {
        return value !== null;
      });

    if (!pageNumbers.length) {
      return 1;
    }

    return Math.max.apply(null, pageNumbers);
  }

  function getItemHrefFromMarkup(markup) {
    var match = markup.match(/href="([^"]*\/products\/[^"]+)"/i);
    return match ? match[1] : markup;
  }

  function getItemSortKey(markup, seed) {
    return hashString(seed + ':' + getItemHrefFromMarkup(markup));
  }

  function getSectionUrl(sectionId, page) {
    var url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);

    if (page > 1) {
      url.searchParams.set('page', String(page));
    } else {
      url.searchParams.delete('page');
    }

    return url.toString();
  }

  function parseGridItemsFromHtml(html, gridSelector, itemSelector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var grid = doc.querySelector(gridSelector);

    if (!grid) {
      return [];
    }

    return Array.prototype.slice.call(grid.querySelectorAll(itemSelector)).map(function (item) {
      return item.outerHTML;
    });
  }

  async function fetchPageItems(sectionId, page, gridSelector, itemSelector) {
    var response = await fetch(getSectionUrl(sectionId, page), {
      credentials: 'same-origin',
    });
    var html = await response.text();

    return parseGridItemsFromHtml(html, gridSelector, itemSelector);
  }

  function buildCacheKey(collectionHandle, seed, sectionId, pathname, searchWithoutPage) {
    return [
      'collection-randomizer',
      collectionHandle,
      seed,
      sectionId,
      pathname,
      searchWithoutPage,
    ].join('|');
  }

  function getSearchWithoutPage() {
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    return url.searchParams.toString();
  }

  async function getAllPageItems(node, gridSelector, itemSelector, seed) {
    var sectionId = document.querySelector(gridSelector).dataset.id;
    var totalPages = getPaginationPages();
    var cacheKey = buildCacheKey(
      node.dataset.collectionHandle,
      seed,
      sectionId,
      window.location.pathname,
      getSearchWithoutPage()
    );

    try {
      var cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        return JSON.parse(cached);
      }
    } catch (error) {
      // Ignore cache failures.
    }

    var requests = [];

    for (var page = 1; page <= totalPages; page += 1) {
      requests.push(fetchPageItems(sectionId, page, gridSelector, itemSelector));
    }

    var pages = await Promise.all(requests);
    var payload = {
      pages: pages,
      totalPages: totalPages,
    };

    try {
      sessionStorage.setItem(cacheKey, JSON.stringify(payload));
    } catch (error) {
      // Ignore cache failures.
    }

    return payload;
  }

  function dedupeItems(markups) {
    var seen = new Set();

    return markups.filter(function (markup) {
      var href = getItemHrefFromMarkup(markup);

      if (seen.has(href)) {
        return false;
      }

      seen.add(href);
      return true;
    });
  }

  function renderCurrentPage(grid, pageItems) {
    grid.innerHTML = pageItems.join('');
  }

  async function applyRandomOrder(node) {
    if (!node) return;

    var collectionHandle = node.dataset.collectionHandle;
    var gridSelector = node.dataset.gridSelector || '#product-grid';
    var itemSelector = node.dataset.itemSelector || '.grid__item';
    var seedMode = node.dataset.seedMode || 'daily';
    var seed = collectionHandle + ':' + getSeed(seedMode);
    var grid = document.querySelector(gridSelector);
    var runId = String(++latestRunId);

    node.dataset.randomizerRunId = runId;

    if (!isAllowedHandle(collectionHandle)) {
      node.dataset.randomizerStatus = 'skipped-handle';
      return;
    }

    if (!grid) {
      node.dataset.randomizerStatus = 'missing-grid';
      return;
    }

    if (grid.dataset.randomizedSeed === seed && grid.dataset.randomizedSearch === getSearchWithoutPage()) {
      node.dataset.randomizerStatus = 'already-randomized';
      grid.style.visibility = '';
      return;
    }

    node.dataset.randomizerStatus = 'loading-pages';
    grid.style.visibility = 'hidden';
    try {
      var payload = await getAllPageItems(node, gridSelector, itemSelector, seed);

      if (node.dataset.randomizerRunId !== runId) {
        return;
      }

      var allItems = dedupeItems(payload.pages.flat());

      if (allItems.length < 2) {
        node.dataset.randomizerStatus = 'not-enough-items';
        grid.style.visibility = '';
        return;
      }

      var pageSize = payload.pages[0] ? payload.pages[0].length : allItems.length;
      var currentPage = getCurrentPage();
      var sortedItems = allItems
        .map(function (markup, originalIndex) {
          return {
            markup: markup,
            originalIndex: originalIndex,
            sortKey: getItemSortKey(markup, seed),
          };
        })
        .sort(function (left, right) {
          if (left.sortKey === right.sortKey) {
            return left.originalIndex - right.originalIndex;
          }

          return left.sortKey - right.sortKey;
        })
        .map(function (entry) {
          return entry.markup;
        });

      var startIndex = (currentPage - 1) * pageSize;
      var endIndex = startIndex + pageSize;
      var pageItems = sortedItems.slice(startIndex, endIndex);

      renderCurrentPage(grid, pageItems);
      grid.dataset.randomizedSeed = seed;
      grid.dataset.randomizedHandle = collectionHandle;
      grid.dataset.randomizedSearch = getSearchWithoutPage();
      grid.style.visibility = '';
      node.dataset.randomizerStatus = 'applied';
      node.dataset.randomizerSeed = seed;
      node.dataset.randomizerPageSize = String(pageSize);
      node.dataset.randomizerTotalItems = String(allItems.length);
    } catch (error) {
      grid.style.visibility = '';
      node.dataset.randomizerStatus = 'error';
    }
  }

  function init() {
    var nodes = Array.prototype.slice.call(
      document.querySelectorAll('[data-collection-randomizer]')
    );

    nodes.forEach(function (node) {
      applyRandomOrder(node);
    });
  }

  function scheduleInit() {
    if (scheduled) return;

    scheduled = true;

    window.requestAnimationFrame(function () {
      scheduled = false;
      init();
    });
  }

  var observer = new MutationObserver(function () {
    scheduleInit();
  });

  document.addEventListener('DOMContentLoaded', scheduleInit);
  document.addEventListener('collection:product-grid:rendered', scheduleInit);
  document.addEventListener('shopify:section:load', scheduleInit);
  window.addEventListener('load', scheduleInit);
  window.addEventListener('pageshow', scheduleInit);
  window.setTimeout(scheduleInit, 50);
  window.setTimeout(scheduleInit, 250);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
